import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  AlertDialog,
  AlertDialogHeader,
  AlertDialogBody,
  Heading,
} from '@americanexpress/dls-react';
import { IconWarning } from '@americanexpress/dls-icons';
import styles from './QuitModal.scss';

const checkIfNullOrUndefined = (value) => value === null || value === undefined;

const QuitModal = ({ modalDetails, languageData }) => {
  const {
    redirectToLandingPage,
    title,
    content,
    continueText,
    exitTextInModal,
    setShow,
    warningMessage,
    handleActionsOnExit = null,
    shouldRedirectOnExit = true,
  } = modalDetails;

  const {
    continueButtonText,
    exitButtonText,
    modalTitle,
    modalBody,
  } = languageData;

  return (
    <AlertDialog
      id="navbar-quit-modal"
      reactlytics={{ disable: true }}
      aria-labelledby="exitModal"
    >
      <AlertDialogHeader
        id="alert-dialog-header"
        className="pad-3-t"
        icon={
          warningMessage ? (
            <IconWarning color="caution" isFilled={true} size="xl" />
          ) : null
        }
      >
        <Heading level={2} variant="sans-small-bold">
          {checkIfNullOrUndefined(title) ? modalTitle : title}
        </Heading>
      </AlertDialogHeader>
      <AlertDialogBody
        id="alert-dialog-body"
        actionSlot={
          (
            <>
              {(continueText || continueButtonText) && (
                <Button
                  className={`margin-1-t ${styles.cursorPointer}`}
                  onClick={() => setShow(false)}
                  {...{
                    reactlytics: {
                      element: 'Continue',
                      detail: 'QuitModal',
                    },
                  }}
                >
                  {continueText || continueButtonText}
                </Button>
              )}
              {(exitTextInModal || exitButtonText) && (
                <Button
                  variant="secondary"
                  className={`${styles.cursorPointer}`}
                  onClick={() => {
                    sessionStorage.setItem('isExitBtnClicked', true);
                    if (handleActionsOnExit) {
                      handleActionsOnExit();
                    }
                    if (shouldRedirectOnExit) {
                      redirectToLandingPage();
                    }
                    setShow(false);
                  }}
                  reactlytics={{
                    element: 'Leave',
                    detail: 'QuitModal',
                  }}
                >
                  {exitTextInModal || exitButtonText}
                </Button>
              )}
            </>
          )
        }
      >
        {warningMessage || (checkIfNullOrUndefined(content) ? modalBody : content)}
      </AlertDialogBody>
    </AlertDialog>
  );
};

QuitModal.propTypes = {
  modalDetails: PropTypes.objectOf(PropTypes.string),
  languageData: PropTypes.objectOf(PropTypes.string),
};

export default QuitModal;
